import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { View } from '@aws-amplify/ui-react';
import { API, Storage } from 'aws-amplify';
import { Alert, Box, Snackbar, Typography } from '@mui/material';
import gql from 'graphql-tag';
import './Training.css';
import {
  UploadTrainingVideo,
  SingleLessonCard,
  LoadingVideoRows,
} from './TrainingComponents';
import { usePermissions } from '../../context/PermissionsContext/PermissionsContext';
import { PermissionKeys } from '../../context/PermissionsContext/permissionTypes';

export const getLessons = async (orgID, API, callbackSetter) => {
  let myNextToken = null;
  const lessons = [];

  const myQuery = gql`
    query MyQuery($orgID: ID!, $nextToken: String) {
      listLessonDetails(
        filter: { orgID: { eq: $orgID }, isDeleted: { eq: false } }
        limit: 200
        nextToken: $nextToken
      ) {
        nextToken
        items {
          id
          name
          description
          youTubeURL
          url
          urlType
          order
          imageName
          imageType
          posterImageName
          category
          createdAt
        }
      }
    }
  `;
  let res;
  try {
    do {
      console.log('Running');
      console.log('nextToken ', myNextToken);
      res = await API.graphql({
        query: myQuery,
        variables: { orgID, nextToken: myNextToken },
      });
      console.log('res ', res);
      const data = res.data.listLessonDetails.items;
      lessons.push(...data);
      myNextToken = res.data.listLessonDetails.nextToken;
    } while (myNextToken);
  } catch (error) {
    console.log('We Got a Problem --- update later  ', error);
    // alert("Couldn't Get Lessons!");
    return false;
  }

  const lessonsObject = {};
  const allLessons = [];
  // for (const lesson of res.data.listLessonDetails.items) {
  for (const lesson of lessons) {
    if (lesson.posterImageName === '') lesson.posterImageName = null;
    if (lesson.youTubeURL === '') lesson.youTubeURL = null;
    if (lesson.youTubeURL) {
      if (lesson.youTubeURL.includes('watch?v='))
        lesson.youTubeURL = lesson.youTubeURL.split('watch?v=')[1];
      if (!lesson.posterImageName) {
        lesson.posterImageName = `https://img.youtube.com/vi/${
          lesson.youTubeURL.split('&')[0]
        }/hqdefault.jpg`;
      } else if (
        !lesson.posterImageName.startsWith('https://img.youtube.com') &&
        !lesson.posterImageName.startsWith('https://i.vimeocdn.com')
      ) {
        const picture = await Storage.get(lesson.posterImageName);
        lesson.posterImageName = picture;
      }
      lesson.videoURL = `https://www.youtube.com/watch?v=${lesson.youTubeURL}`;
    } else {
      lesson.videoURL =
        'https://d22xeeaijfewl2.cloudfront.net/public/' +
        encodeURIComponent(lesson.imageName);
      if (
        lesson.posterImageName &&
        !lesson.posterImageName.startsWith('https://img.youtube.com') &&
        !lesson.posterImageName.startsWith('https://i.vimeocdn.com')
      ) {
        const picture = await Storage.get(lesson.posterImageName);
        lesson.posterImageName = picture;
      }
    }
    if (!lessonsObject[lesson.category]) lessonsObject[lesson.category] = [];
    lessonsObject[lesson.category].push(lesson);
    allLessons.push(lesson);
  }
  Object.keys(lessonsObject).forEach((category) => {
    lessonsObject[category] = lessonsObject[category].sort(
      (a, b) => a.order - b.order
    );
  });

  callbackSetter(lessonsObject);
  global.trainingVideos = lessonsObject;
};

export default function TrainingHomePage() {
  const orgID = global.me.orgID;
  const navigate = useNavigate();

  const { checkPermission } = usePermissions();

  const canManage = checkPermission(PermissionKeys.Other_ManageTrainingVideos);

  const [allLessons, setAllLessons] = useState({});
  const [recentUploads, setRecentUploads] = useState([]);
  const [uploadVid, setUploadVid] = useState(false);
  const [snackbarObj, setSnackbarObj] = useState(null);

  const recentUploadsReducer = (lessonsObj) => {
    if (!lessonsObj || typeof lessonsObj !== 'object') {
      return [];
    }
    return Object.values(lessonsObj)
      .reduce((acc, el) => [...acc, ...el], [])
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  };

  useEffect(() => {
    if (global.trainingVideos) {
      setAllLessons(global.trainingVideos);
      setRecentUploads(recentUploadsReducer(global.trainingVideos));
    } else {
      getLessons(orgID, API, (res) => {
        if (res) {
          setAllLessons(res);
          setRecentUploads(recentUploadsReducer(res));
        } else {
          console.error('Failed to fetch lessons');
          setAllLessons({});
          setRecentUploads([]);
        }
      });
    }
  }, [global.trainingVideos]);

  return (
    <View
      style={{
        paddingTop: '40px',
      }}
    >
      <Box id="training-home-container">
        <Box id="training-home-topbar">
          <Box id="page-title-box">
            <Typography
              style={{
                fontWeight: '700',
                fontSize: '1.7rem',
                marginRight: '0.7vw',
              }}
              className="hov"
            >
              Training
            </Typography>
            {canManage && (
              <Typography
                sx={{
                  color: (theme) => theme.custom.primary,
                  fontWeight: '700',
                  transform: 'translateY(-3px)',
                }}
                className="hov"
                onClick={() => {
                  setUploadVid(true);
                }}
              >
                + Add Media
              </Typography>
            )}
          </Box>
          {/* <Box id="type-selection-box">
            <Box className="training-type-option">
              <Text
                style={{
                  color: '#FF6A00',
                  fontSize: '1rem',
                  fontWeight: '700',
                }}
              >
                Videos
              </Text>
              <Box className="dot" style={{ backgroundColor: '#FF6A00' }} />
            </Box>
            <Box className="training-type-option">
              <Text
                style={{
                  color: '#868686',
                  fontSize: '1rem',
                  fontWeight: '700',
                }}
              >
                Documents
              </Text>
            </Box>
          </Box> */}
        </Box>
        {allLessons ? (
          <>
            <Box className="category-row-continaer">
              <Box className="category-row-top">
                <Typography style={{ fontWeight: 700, fontSize: '1.3rem' }}>
                  Recently Uploaded
                </Typography>
              </Box>
              <Box className="category-row-lessons-container">
                {recentUploads.slice(0, 4).map((lesson, i) => (
                  <SingleLessonCard
                    lesson={lesson}
                    refresh={() => {
                      getLessons(orgID, API, (res) => {
                        if (res) {
                          setAllLessons(res);
                          setRecentUploads(recentUploadsReducer(res));
                        } else {
                          console.error('Failed to fetch lessons');
                        }
                      });
                    }}
                    snackbar={(message, severity) =>
                      setSnackbarObj({ message, severity })
                    }
                    key={i}
                    display="grid"
                  />
                ))}
              </Box>
            </Box>
            {Object.keys(allLessons).map((category, i) => (
              <Box key={i} className="category-row-continaer">
                <Box className="category-row-top">
                  <Typography style={{ fontWeight: 700, fontSize: '1.3rem' }}>
                    {category}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      color: (theme) => theme.custom.primary,
                    }}
                    onClick={() => navigate(`/training/${category}`)}
                    className="hov"
                  >
                    View All
                  </Typography>
                </Box>
                <Box className="category-row-lessons-container">
                  {allLessons[category].map((lesson, i) => (
                    <SingleLessonCard
                      lesson={lesson}
                      refresh={() => {
                        getLessons(orgID, API, (res) => {
                          if (res) {
                            setAllLessons(res);
                            setRecentUploads(recentUploadsReducer(res));
                          } else {
                            console.error('Failed to fetch lessons');
                          }
                        });
                      }}
                      key={i}
                      display="grid"
                      snackbar={(message, severity) =>
                        setSnackbarObj({ message, severity })
                      }
                    />
                  ))}
                </Box>
              </Box>
            ))}
          </>
        ) : (
          <>
            <LoadingVideoRows />
            <LoadingVideoRows />
          </>
        )}
      </Box>
      <UploadTrainingVideo
        open={uploadVid}
        close={() => setUploadVid(false)}
        refresh={() => {
          getLessons(orgID, API, (res) => {
            if (res) {
              setAllLessons(res);
              setRecentUploads(recentUploadsReducer(res));
            } else {
              console.error('Failed to fetch lessons');
            }
          });
        }}
        snackbar={(message, severity) => setSnackbarObj({ message, severity })}
      />
      {/* <EditTrainingVideo open={editLesson} close={() => setEditLesson(null)} /> */}
      {/* <Snackbar open={true} message="hello" severity="info" /> */}
      {snackbarObj && (
        <Snackbar
          autoHideDuration={6000}
          onClose={() => setSnackbarObj(null)}
          open={Boolean(snackbarObj)}
        >
          <Alert severity={snackbarObj.severity}>{snackbarObj.message}</Alert>
        </Snackbar>
      )}
    </View>
  );
}
